<template>
<div class="menuBody"  style="padding-left:25px;">
    <OrganizationalStructure @AllData="getMsgFormSon"  style="display:none" />
        <ChargeDialog :param="diaLogData" @Visible="Visible" ref="ChargeDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:150px;float:left;margin-right:30px;margin-top:10px">
                收款方式列表
            </div>
            <div style="float:right">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:cms:save'" @click="PropertyAdd()">添加收款方式</el-button>
            </div>

            <el-table  :data="tableData" tooltip-effect="light"     v-loading="loading"
            style="overflow-y: scroll;float:right;margin-top:30px" 
            row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column label="序号"  type="index" width="60px" ></el-table-column>
        <el-table-column show-overflow-tooltip prop="methodName" label="收款方式"  ></el-table-column>
        <el-table-column show-overflow-tooltip prop="isService" label="是否有手续费" >
        <template slot-scope="scope">
        <el-tag type="warning" v-if="scope.row.isService=='0'" >否</el-tag>
        <el-tag type="success" v-if="scope.row.isService=='1'" >是</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="serviceRate" label="手续费费率 %" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注信息"></el-table-column>
    <el-table-column fixed="right" label="操作" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改" v-Jurisdiction="'expense:web:cs:cms:save'"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除" v-Jurisdiction="'expense:web:cs:cms:delete'" v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import ChargeDialog from "../common/ChargeDialog";
import OrganizationalStructure from "../common/OrganizationalStructure.vue";

export default {
  name: "ChargeSet",
  components: {ChargeDialog,OrganizationalStructure},
  data() {
    return {
 
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        CourseCode:"",
        CourseName:"",
        UpCourseCode:"",
      tableData: [],
      options: [{
          value: '选项1',
          label: '是'
        }, {
          value: '选项2',
          label: '否'
        }],
        value: '',
       optionsone: [{
          valueone: '选项1',
          labelone: '全部'
        }, {
          valueone: '选项2',
          labelone: '正式员工'
        }, {
          valueone: '选项3',
          labelone: '外包员工'
        }],
        valueone: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERList:"",
      ProjectMana:"",
    }
  },
  methods: {
    getMsgFormSon(data){
      this.AllData = data
    },
  handleSizeChange(val) {
    this.loading = true
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
      this.loading = true
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
        // 查询
         let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "subjectsCode":this.CourseCode, 
        "subjectsName":this.CourseName, 
        "parentCode":this.UpCourseCode, 
        "expendItem":this.value 
      }
        this.$http.post(this.$requestUrl.POST_RECEIPT_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
               this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页条数
      }
        this.$http.post(this.$requestUrl.POST_RECEIPT_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
               this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })
      },
    PropertyAdd(){
        // 添加项目
      this.$refs.ChargeDialog.title = "添加";
      this.$refs.ChargeDialog.dialogVisible = true; 
      this.$refs.ChargeDialog.type = "收款";
      this.$refs.ChargeDialog.valueone = ""
         let obj = {
            "code":"收款方式",
            "name":"是否有手续费",
            "site":"手续费费率",
            "floor":"备注信息",
          }
          let row = {}
          row.obj = obj
 
         this.$refs.ChargeDialog.formLabelAlign= row;
    },
    editMenu(row) { // 修改
      this.$refs.ChargeDialog.title = "修改";
      this.$refs.ChargeDialog.dialogVisible = true; 
      this.$refs.ChargeDialog.valueone = row.isService
      this.$refs.ChargeDialog.type = "收款";
           let obj = {
            "code":"收款方式",
            "name":"是否有手续费",
            "site":"手续费费率",
            "floor":"备注信息",
          }
        row.obj = obj
 
         this.$refs.ChargeDialog.formLabelAlign= row;
        },
        delMenu(row){
    this.$confirm('是否确认要删除该方式?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
    this.$http.post(this.$requestUrl.POST_DELETE_RECEIPT+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.loading = true
          this.getAllMenu()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
          // 删除
    },
    text(){
      this.$http.get(this.$requestUrl.GET_LIST).then((res)=>{
         
      }).catch((err) => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    Visible(data){
      if(data == false){
        this.loading = true
       this.getAllMenu()
      }
    }
  },
  mounted() {
      this.getAllMenu();
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>